import React from "react";
import PropTypes from "prop-types";
import StyledButton from "../StyledButton/StyledButton";
import styled, { withTheme } from "styled-components";

const StyledOutlineBtn = styled(StyledButton)`
  color: ${(props) =>
    props?.type === "danger"
      ? props?.theme?.chiliRed
      : props?.theme?.darkPurple} !important;
  background-color: ${(props) => props?.theme?.glassy} !important;
  border-color: ${(props) =>
    props?.type === "danger"
      ? props?.theme?.chiliRed
      : props?.theme?.darkPurple} !important;

  &.show-icon {
    position: relative;
    padding: 0.5rem 1rem 0.5rem 2rem;
    min-width: 130px;
    &:last-child {
      margin-left: 4px;
    }
    i {
      position: absolute;
      left: 15px;
      top: 12px;
    }
  }
`;

const AuditTrailOutlineButton = (props) => {
  const { text, size, className, type = "accent", icon = null } = props;

  return (
    <StyledOutlineBtn
      {...props}
      size={size}
      type={type}
      className={`${icon && "show-icon btn-sm"} ${className}`}
    >
      {icon && <i className={icon} />}
      {text || props.children}
    </StyledOutlineBtn>
  );
};

AuditTrailOutlineButton.propTypes = {
  size: PropTypes.oneOf(["lg", "", "sm"]),
  text: PropTypes.string,
  type: PropTypes.oneOf(["danger", "accent"]),
  className: PropTypes.string,
};

export default withTheme(AuditTrailOutlineButton);
